import BGPattern from '../../../assets/common/bg-pattern.svg';
import entitlementsGetStarted2 from '../../../assets/common/entitlements-get-started-placeholder.svg';
import activateProduct from '../../../assets/csg/activate-product.svg';
import dashboardArchitectureImage from '../../../assets/csg/architecture_summary.png';
import dashboardBetaTestImage from '../../../assets/csg/beta-test.svg';
import dontUseEntitlementServer from '../../../assets/csg/dont-use-entitlement-server.svg';
import entitlementsGetStarted from '../../../assets/csg/entitlements-get-started.png';
import dashboardGoLiveImage from '../../../assets/csg/go-live.svg';
import backgroundLoginImage from '../../../assets/csg/login-background.png';
import logo from '../../../assets/csg/logo.svg';
import logoLight from '../../../assets/csg/logo-light.svg';
import logoMini from '../../../assets/csg/logo-mini.svg';
import dashboardIntro1Image from '../../../assets/csg/onboarding-intro.svg';
import dashboardPreRequisitesImage from '../../../assets/csg/prerequisites.svg';
import dashboardProductionReadinessImage from '../../../assets/csg/production-readiness.svg';
import useEntitlementServer from '../../../assets/csg/use-entitlement-server.svg';
import { Config } from './types/brands';

export const csgConfig: Config = {
  context: 'csg',
  assets: {
    activateProduct,
    backgroundLoginImage,
    dashboardEntitlementsHeader: entitlementsGetStarted,
    dontUseEntitlementServer,
    entitlementsGetStarted,
    entitlementsGetStarted2,
    logoMini,
    logo,
    logoLight,
    useEntitlementServer,
    onboarding: {
      dashboardIntro1: dashboardIntro1Image,
      architecture: dashboardArchitectureImage,
      prerequisites: dashboardPreRequisitesImage,
      productionReadiness: dashboardProductionReadinessImage,
      betaTest: dashboardBetaTestImage,
      goLive: dashboardGoLiveImage,
    },
    reviewBgPattern: BGPattern,
  },
  i18n: {
    variables: {
      companyName: 'CSG',
      productName: 'Entitlements-as-a-Service, powered by NetLync',
      productFullName: 'CSG Entitlements',
      portalFullName: 'CSG Entitlements Developer Portal',
      saasFullName: 'CSG Entitlements as a Service',
      supportEmail: 'support@netlync.com',
      productionSupportEmail: 'productionsupport@csg.com',
      productionSupportTickets: 'productionsupport@csg.com',
      uesContractUrl: '',
    },
  },
  environments: {
    settings: {
      companyFlag: 'csg',
      sideMenuLogoHeight: '55px',
      sideMenuLogoPadding: '12px 0',
      termOfServiceUrl: 'https://www.csgi.com/terms-of-use/',
      privacyPolicyURL: 'https://www.csgi.com/privacy/',
      cookiesPolicyURL: '/cookie-policy',
      imprintUrl: undefined,
      poweredBy: 'Powered by NetLync',
    },
  },
};
